import React from 'react';

const CopyRow = ({ label, value, copyValue, monospace, onCopied }) => {
  const handleCopy = async () => {
    const textToCopy = copyValue !== undefined ? String(copyValue) : value;
    await navigator.clipboard.writeText(textToCopy);
    onCopied(label);
  };

  return (
    <div className="d-flex justify-content-between align-items-center mb-1">
      <div>
        <strong>{label}:</strong>{' '}
        <span className={monospace ? 'text-monospace' : ''}>
          {value}
        </span>
      </div>
      <i
        className="bi bi-clipboard cursor-pointer"
        onClick={handleCopy}
        title="Скопіювати"
      />
    </div>
  );
};

export default CopyRow;